import { createSelector } from '@reduxjs/toolkit'
import { sortBy, values, pickBy } from 'lodash-es'

function getBase(state, props) {
  return state.data.groups
}

export const getGroup = function (state, props) {
  const { groupId } = props
  const idString = groupId.toString()
  return getBase(state, props)[idString]
}

export const getGroups = function (state, props) {
  return getBase(state, props)
}

export const getGroupsList = createSelector([getGroups], function (groups) {
  return sortBy(values(groups), group => group.name)
})

export const selectGroupsByIds = createSelector(
  (state, props) => props, // array of group ids
  getGroups,
  function (groupIds, allGroups) {
    const groupIdSet = new Set(groupIds.map(String)) // Convert all ids to strings
    return pickBy(allGroups, (group, groupId) => groupIdSet.has(groupId))
  }
)

export const selectGroupsListByIds = createSelector(selectGroupsByIds, groupsArray => {
  return values(groupsArray)
})
